module.exports = __webpack_public_path__ + "img/BlankProfilePic.fdb565d1.png";